import React from 'react'
import { DataTable } from '@softwaredev_cegeka/stix-data-table'
import Alert from '@softwaredev_cegeka/stix-core/dist/components/Alert'
import { Filter } from '@softwaredev_cegeka/stix-filter'

export function hasData(data) {
    return data && data.length !== 0
}

function EntityTable(props) {
    const {
        columnsTofilter,
        data,
        columns,
        loading,
        onColumnFilter,
        onGlobalFilter,
        globalFilter,
        ...rest
    } = props
    const memData = React.useMemo(() => data, [data])
    const memColumns = React.useMemo(() => columns, [columns])
    const placeholderData = [...Array(10)].map(i => ({}))

    function applyHeaderFilters(values) {
        let entries = Object.entries(values).map(([key, value]) => ({
            [key]: value,
        }))
        onColumnFilter(entries)
    }

    function handleGlobalFilterChange(value) {
        onGlobalFilter(value)
    }

    return (
        <>
            <DataTable
                {...rest}
                data={hasData(data) ? memData : placeholderData}
                loading={loading || !hasData(data)}
                columns={memColumns}
                pageSize={data.length || 10}
                variant={'compact'}
                manualPagination
                headerComponent={
                    <Filter
                        filters={columnsTofilter}
                        onFilterChange={applyHeaderFilters}
                        onChangeGlobalFilter={handleGlobalFilterChange}
                        globalFilter={globalFilter}
                    />
                }
            />
            {!hasData(data) && loading === false ? (
                <Alert variant="info">0 results found</Alert>
            ) : null}
        </>
    )
}

export default EntityTable
